// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "47f52822a-dirty",
    "hash": "47f52822a",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "47f52822a-dirty",
    "semverString": null,
    "version": "0.0.0",
    "buildDate": "7/3/2025",
    "buildTime": "Thu, 03 Jul 2025 09:01:51 GMT"
};
/* eslint:enable */
